import { useState, useCallback } from "react";
import formatCurrency from "@/utils/formatCurrency";

const CalculatorInputField = ({ label, value, onChange, icon: Icon, suffix = '', min = 0, max, step = 1 }) => {
  const isCurrency = suffix === '₹';
  const [isFocused, setIsFocused] = useState(false);

  const handleCurrencyChange = useCallback((e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    const parts = raw.split('.');
    const sanitized = parts[0] + (parts.length > 1 ? '.' + parts.slice(1).join('') : '');
    onChange(parseFloat(sanitized) || 0);
  }, [onChange]);

  let displayValue = value;
  if (isCurrency) {
    if (isFocused) {
      displayValue = value || "";
    } else {
      displayValue = value ? `₹${formatCurrency(value)}` : "";
    }
  }

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="relative">
        {Icon && <Icon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />}
        <input
          type={isCurrency ? "text" : "number"}
          inputMode={isCurrency ? "decimal" : undefined}
          className={`w-full ${Icon ? 'pl-10' : 'pl-4'} pr-12 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-teal-400 focus:ring-2 focus:ring-teal-100`}
          value={displayValue}
          onChange={isCurrency ? handleCurrencyChange : (e) => onChange(parseFloat(e.target.value) || 0)}
          onFocus={isCurrency ? () => setIsFocused(true) : undefined}
          onBlur={isCurrency ? () => setIsFocused(false) : undefined}
          min={isCurrency ? undefined : min}
          max={isCurrency ? undefined : max}
          step={isCurrency ? undefined : step}
          placeholder={isCurrency ? "₹0" : undefined}
        />
        {suffix && !isCurrency && <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">{suffix}</span>}
      </div>
    </div>
  );
};

export default CalculatorInputField;
